/**
 * Overseas territories (Outre-Mer) configuration
 * Centralized list of overseas territories and domain checks
 *
 * @file Overseas territory definitions and helpers
 */

/**
 * Overseas territories configuration
 * @type {Object}
 */
const OVERSEAS_TERRITORIES = {
  // Domain name constants
  REUNION: 'Réunion',
  MAYOTTE: 'Mayotte',
  GUYANE: 'Guyane',
  NOUVELLE_CALEDONIE: 'Nouvelle-Calédonie',
  POLYNESIE_AUSTRALES: 'Polynésie-française-Australes',
  POLYNESIE_TUAMOTU: 'Polynésie-française-Tuamotu',
  POLYNESIE_SOCIETE: 'Polynésie-française-Société',
  GUADELOUPE: 'Guadeloupe',
  MARTINIQUE: 'Martinique',
  SAINT_MARTIN_SAINT_BARTHELEMY: 'Saint-Martin-Saint-Barthélemy',

  /**
   * List of overseas territory domain names (currently available)
   * Used for domain-specific logic (reference periods, data sources, etc.)
   * @returns {Array<string>} Array of overseas territory domain names
   */
  get domains() {
    return [
      this.REUNION,
      this.MAYOTTE,
      this.GUYANE,
      this.NOUVELLE_CALEDONIE,
      this.POLYNESIE_AUSTRALES,
      this.POLYNESIE_TUAMOTU,
      this.POLYNESIE_SOCIETE,
      this.GUADELOUPE,
      this.MARTINIQUE,
      this.SAINT_MARTIN_SAINT_BARTHELEMY,
    ];
  },

  /**
   * Check if a domain is an overseas territory
   * @param {string} domaine - Domain name from entity.domaine
   * @returns {boolean} True if domain is overseas
   */
  isOverseas: (domaine) => OVERSEAS_TERRITORIES.domains.includes(domaine),

  /**
   * Check if a department name is overseas (for entity enrichment)
   * @param {string} departmentName - Department name from entity.nom_departement
   * @returns {boolean} True if department is overseas
   */
  isDepartmentOverseas: (departmentName) => OVERSEAS_TERRITORIES.domains.includes(departmentName),
};

// Grouped territories for indicator preselection logic
OVERSEAS_TERRITORIES.REUNION_MAYOTTE = [
  OVERSEAS_TERRITORIES.REUNION,
  OVERSEAS_TERRITORIES.MAYOTTE,
];

OVERSEAS_TERRITORIES.POLYNESIE_ALL = [
  OVERSEAS_TERRITORIES.POLYNESIE_AUSTRALES,
  OVERSEAS_TERRITORIES.POLYNESIE_TUAMOTU,
  OVERSEAS_TERRITORIES.POLYNESIE_SOCIETE,
];

export default OVERSEAS_TERRITORIES;
